<template>
  <div>
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12"
              sm="9"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar Cupos Asignados
            </v-col>
            
            <v-col 
              cols="12"
              sm="3"
            >
              <v-text-field
                outlined
                dense
                hide-details
                append-icon="mdi-magnify"
                label="Buscar Categoria"
                v-model="searchTable"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="cuposAsignados"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" >
                <v-icon
                  color="primary"
                  v-bind="attrs" 
                  v-on="on"
                  class="mr-2"
                  @click="detallesCategoria(item.categoria_id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }" >
                <v-icon
                  color="primary"
                  v-bind="attrs" 
                  v-on="on"
                  @click="gestionarParticipantes(item.categoria_id)"
                >
                  mdi-account-plus
                </v-icon>
              </template>
              <span>Gestionar Participantes</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    headersTable: [
      {
        text: "Categoria",
        value: "categoria",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "# Cupos",
        value: "numero_participantes",
        align: "start",
        sortable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ]
  }),

  mounted() {
    this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    usuario() {
      return this.$store.getters.usuario;
    },

    cuposAsignados() {
      return this.$store.getters.obtenerCuposAsignados(this.usuario.centro_formacion_id);
    }
  },

  methods: {
    detallesCategoria(idCategoria) {
      this.$router.push({
        name: "cupo-detalle",
        params: { id_categoria: idCategoria }
      })
    },

    gestionarParticipantes(idCategoria) {
      this.$router.push({
        name: "participante-gestionar",
        params: { id_competencia: this.$route.params.id_competencia, id_categoria: idCategoria }
      });
    },

    regresar() {
      this.$router.back()
    }
  }
};
</script>